export { classifyError } from './classifyError';
export type { ClassifiedError, ErrorKind } from './classifyError';
export { classifyForbidden } from './classifyForbidden';
export type { ForbiddenClassification, ForbiddenKind } from './classifyForbidden';
export { parseValidationErrors } from './parseValidationErrors';

import { reportClassifiedError } from '../observability/sentry';
import { classifyError as _classifyError } from './classifyError';

/**
 * Retorna mensagem de erro visível ao usuário, ou null para erros de auth
 * (401 _authHandled) que o interceptor já trata via redirect.
 */
export function getUserVisibleErrorMessage(error: unknown): string | null {
  const classified = _classifyError(error);
  if (classified.isAuthError) return null;
  return classified.message;
}

/**
 * Wrapper para onError de mutations.
 * Filtra erros de auth e notifica via callback. Reporta ao Sentry conforme
 * SENTRY_POLICY (breadcrumb para fluxo esperado, captureException para bugs).
 *
 * Uso simples: `onError: (err) => notifyMutationError(err, showError)`
 * Com cleanup: `onError: (err) => { rollback(); notifyMutationError(err, showError); }`
 */
export function notifyMutationError(
  error: unknown,
  notify: (message: string) => void,
): void {
  const classified = _classifyError(error);
  reportClassifiedError(error, classified);
  if (!classified.isAuthError) {
    notify(classified.message);
  }
}
